(() => {
  const sync = () => {
    document.querySelectorAll('[data-section-type="main-product"]').forEach((section) => {
      const badgeSource = section.querySelector('.gallery:not(.rio-media-gallery) .product-pdp-badge');
      const mediaGallery = section.querySelector('.rio-media-gallery');
      const mediaGallerySticky = mediaGallery?.querySelector(':scope > div');
      const detachedBadge = mediaGallery?.querySelector(':scope > .product-pdp-badge');

      if (badgeSource && mediaGallerySticky && !mediaGallerySticky.querySelector(':scope > .product-pdp-badge')) {
        mediaGallerySticky.append(detachedBadge || badgeSource.cloneNode(true));
      }

      const fillSizeSource = section.querySelector('.option-selectors .product-fill-size');
      const productOptions = section.querySelector('.rio-options');

      if (fillSizeSource && productOptions && !productOptions.querySelector(':scope > .product-fill-size')) {
        productOptions.append(fillSizeSource.cloneNode(true));
      }

      const findMyShadeButton = section.querySelector('[data-find-my-shade-trigger]');
      const findationButton = section.querySelector('#findation-button-iframe');

      if (findMyShadeButton && findationButton) {
        findMyShadeButton.hidden = false;
      }
    });
  };

  if (window.cielePdpMetafields) {
    window.cielePdpMetafields.sync();
    return;
  }

  let animationFrame;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(animationFrame);
    animationFrame = requestAnimationFrame(sync);
  });

  window.cielePdpMetafields = { sync };

  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-find-my-shade-trigger]');

    if (!trigger) return;

    event.preventDefault();

    if (window.Findation && typeof window.Findation.openWidget === 'function') {
      window.Findation.openWidget();
    }
  });
  sync();
})();
